<template>
  <div class="page-content" id="releaseMess">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/MessageCenter/:id' }">消息中心</el-breadcrumb-item>
      <el-breadcrumb-item>发布消息</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="消息主题" prop="topic">
          <el-input placeholder="请输入内容" v-model="ruleForm.topic" size="small" style="width: 425px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="消息内容" style="position: relative;" :required="true">
          <div id="editor" class="editor" style="width: 717px;height: 351px;"></div>
          <div style="background-color: white;position: absolute;top: 352px;width: 90px;height: 18px;z-index: 900;color: white;" v-show="wildWest">1</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" size="small" :loading="loadingUpDe">确 定</el-button>
          <el-button @click="resetForm" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
import E from 'wangeditor';
export default {
  data () {
    return {
      ruleForm: {
        topic: '',
      },
      rules: {
        topic: [
          { required: true, message: '请输入消息主题', trigger: 'blur' }
        ],
      },
      wildWest: false,
      loadingUpDe: false,
    }
  },

  methods: {
    wangEditor() {
      var editor = new E('#editor')
        editor.customConfig.onchange = (html) => {
          this.formArticle = html
        }
        editor.customConfig.uploadImgServer = '<%=path%>/Img/upload'; //上传URL
        editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
        editor.customConfig.uploadImgMaxLength = 5;
        editor.customConfig.uploadFileName = 'myFileName';
        editor.customConfig.uploadImgHooks = {
        customInsert: function (insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          var url =result.data;
          insertImg(url);

          // result 必须是一个 JSON 格式字符串！！！否则报错
        }
      }
      editor.create();
    },
    submitForm(formName) {
      console.log(this.formArticle)
      if (!this.formArticle) {
        this.$message({
          message: '请填写消息内容',
          type: 'warning'
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (this.formArticle != undefined) {
          this.wildWest = true
        }
        if (valid) {
          this.loadingUpDe = true
          let params={
            topic: this.ruleForm.topic,
            content: this.formArticle,
          }
          fetch({
            url: "hcm/hcmMessageCenter/save",
            method: "post",
            data: params,
            noFormat: true,
            responseType: "text",
            timeout: 60 * 1000 * 5
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.loadingUpDe = false
              this.$message({
                message: '新增成功',
                type: 'success'
              });
              this.$router.push('/MessageCenter/:id')
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              });
              this.loadingUpDe = false
            }
          }).catch(err => {
            this.$message.error('接口异常');
          });
        }
      });
    },
    resetForm() {
      this.$router.push({
        path: '/MessageCenter'
      })
    },
  },

  mounted() {
    this.wangEditor();
  },
}
</script>


<style lang='scss'>
#releaseMess {
  .page {
    padding: 20px;
    background-color: white;
  }
}
</style>
